import { create } from 'zustand'

import { gridSize, gridSizeStore } from './types'

export const useGridSize = create<gridSizeStore>()((set) => ({
  currentGridSize: 'md',
  setCurrentGridSize: (size: gridSize) => set({ currentGridSize: size }),
}))
